import { AssetRole } from '@/api/model/asset';
import { type EventPayload } from '@/api/model/subscription-topic';

export enum UploadStages {
    PREPARING = 0,
    UPLOADING = 1,
    PROCESSING = 2,
    DONE = 3
}

export type StageType = UploadStages.PREPARING | UploadStages.UPLOADING | UploadStages.PROCESSING | UploadStages.DONE;

export type StageCallback = (stage: StageType) => void;
export type ErrorCallback = (error: string) => void;
export type CompletionCallback = (payload: EventPayload) => void;

export interface Dimensions {
    width: number;
    height: number;
}

export type VideoMetadata = {
    name: string;
    type: string;
}

export interface UploadOptionsBase {
    role: AssetRole;
    email: string;
    jumpId?: string;
    competitionId?: string;
    onStage: StageCallback;
}

export interface UploaderOptions extends UploadOptionsBase {
    file: File;
}


export interface RecorderOptions extends UploadOptionsBase {
    info: VideoMetadata;
}